import lw3Img from "../assets/img/learnweb3.png";
import swapImg from "../assets/img/swap.png";
import ecomImg from "../assets/img/ecom.png"
import taskImg from "../assets/img/task.png"
import ycImg from "../assets/img/yc.png"
import dojoImg from "../assets/img/dojo.png"
import blogImg from "../assets/img/blog.png"
import portImg from "../assets//img/port.png"
import sassImg from "../assets/img/sass.png"
import tailImg from "../assets/img/tail.png"
import candyImg from "../assets/img/candy.png"
import gitImg from "../assets/img/github_cover.jpeg"

const projects = [
    {
      title: "LearnWeb3",
      description: "Full Stack Development",
      imgUrl: lw3Img,
      url: "https://learnweb3.io/"
    },
    {
      title: "Swap Solutions ",
      description: "Full Stack Development",
      imgUrl: swapImg,
      url: "https://swapsolutions.ca/"
    },
    {
      title: "Ecommerce Website",
      description: "Frontend + CMS",
      imgUrl: ecomImg,
      url: "https://github.com/MohanpreetS/Ecommerce-Website"
    },
    {
      title: "Task Manager",
      description: "Fullstack + ORM",
      imgUrl: taskImg,
      url: "https://github.com/MohanpreetS/Task-Manager-NextJS"
    },
    {
      title: "Ticketing Website",
      description: "APIs+Database",
      imgUrl: dojoImg,
      url: "https://github.com/MohanpreetS/NextJS_practice"
    },
    {
      title: "Portfolio",
      description: "Frontend Development",
      imgUrl: portImg,
      url: "https://github.com/MohanpreetS/webdev_portfolio"
    },
    
  ];

  const projects2 = [
    {
      title: "YelpCamp",
      description: "MERN Stack",
      imgUrl: ycImg,
      url: "https://github.com/MohanpreetS/YelpCamp_project"
    },
    {
      title: "MySQL Blog",
      description: "Backend+SQL",
      imgUrl: blogImg,
      url: "https://github.com/MohanpreetS/MySQL-Blog-Website"
    },
    
    {
      title: "SASS project",
      description: "Frontend",
      imgUrl: sassImg,
      url: "https://github.com/MohanpreetS/SASS_course"
    },
    {
      title: "Tailwind project",
      description: "Frontend",
      imgUrl: tailImg,
      url: "https://github.com/MohanpreetS/tailwind_crash_course"
    },
    {
      title: "Candy Museum",
      description: "Frontend + CSS",
      imgUrl: candyImg,
      url: "https://github.com/MohanpreetS/museum_of_candy"
    },
    {
      title: "URL Shortener",
      description: "Backend",
      imgUrl: gitImg,
      url: "https://github.com/MohanpreetS/URL-Shortener"
    },
  ];

  const projects3 = [
    {
      title: "JWT/OAuth Practice",
      description: "Backend + Auth",
      imgUrl: gitImg,
      url: "https://github.com/MohanpreetS/JWT_OAuth_practice"
    },
    {
      title: "Docker Practice",
      description: "Full Stack Development",
      imgUrl: gitImg,
      url: "https://github.com/MohanpreetS/Docker-Tutorial"
    },
    {
      title: "Typescript Practice",
      description: "Typescript",
      imgUrl: gitImg,
      url: "https://github.com/MohanpreetS/Angular-Typescript-Practice"
    },
    {
      title: "Flutter Projects",
      description: "Flutter",
      imgUrl: gitImg,
      url: "https://github.com/MohanpreetS/flutter_projects"
    },
    {
      title: "Mongo Express practice",
      description: "APIs+Database",
      imgUrl: gitImg,
      url: "https://github.com/MohanpreetS/MongoExpress_practice"
    },
    {
      title: "React Tutorial",
      description: "React JS",
      imgUrl: gitImg,
      url: "https://github.com/MohanpreetS/react_practice"
    },
  ];

export {projects, projects2, projects3};
